module.exports = __webpack_public_path__ + "img/viewCampaign.34f1b0fa.png";